import { createApp, h } from 'vue'
import ToastComponent from './index.vue'

let instance = null

/**
 * 显示顶部 Toast 通知（从顶部滑入，内容左对齐 + 右侧关闭按钮）
 * @param {object|string} options - 配置对象或消息字符串
 * @param {string} options.message - 通知内容
 * @param {string} [options.type='info'] - 通知类型 info/danger/primary/warning
 * @param {number} [options.duration=2000] - 显示时长(ms)
 * @param {string} [options.color] - 自定义文字颜色
 * @param {string} [options.background] - 自定义背景色
 * @returns {void}
 */
export function showToast(options) {
  const opts = typeof options === 'string' ? { message: options } : options

  if (instance) {
    instance.unmount()
    if (instance._container && instance._container.parentNode) {
      document.body.removeChild(instance._container)
    }
    instance = null
  }

  const container = document.createElement('div')
  document.body.appendChild(container)

  const app = createApp({
    setup() {
      const visible = ref(true)

      const onClose = () => {
        visible.value = false
        opts.onClose?.()
        setTimeout(() => {
          app.unmount()
          if (container.parentNode) {
            document.body.removeChild(container)
          }
          instance = null
        }, 300)
      }
      const duration = opts.duration ?? 2000
      if (duration > 0) {
        setTimeout(onClose, duration)
      }
      return () =>
        h(ToastComponent, {
          modelValue: visible.value,
          'onUpdate:modelValue': val => {
            visible.value = val
          },
          message: opts.message || '',
          type: opts.type || 'info',
          duration: opts.duration ?? 2000,
          color: opts.color || '',
          background: opts.background || '',
          onClose,
        })
    },
  })

  instance = app
  instance._container = container
  app.mount(container)
}

/**
 * 关闭顶部 Toast 通知
 */
export function closeToastNotify() {
  if (instance) {
    instance.unmount()
    if (instance._container && instance._container.parentNode) {
      document.body.removeChild(instance._container)
    }
    instance = null
  }
}
